var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fullscreen',{attrs:{"index":998}},[_c('panel-call-details',_vm._b({scopedSlots:_vm._u([{key:"panel__header",fn:function(){return [(_vm.data.audioUrl)?_c('base-audio',{attrs:{"settings":{
                    id: _vm.id,
                    requestId: _vm.$route.params.id,
                    model: _vm.$route.meta.api
                }}}):_vm._e()]},proxy:true}])},'panel-call-details',{
            headerClass: 'call__header',
            data: _vm.data,
            specificData: {
                allowFilling: false,
                isOperateMenu: false
            },
            close: {
                show: true,
                action: _vm.closeView
            }
        },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }